import { makeAuthorizedRequest } from './requests';

export function getNotifications() {
  return makeAuthorizedRequest('GET', '/notifications');
}

export function updateNotification(notificationId) {
  return makeAuthorizedRequest('PUT', `/notifications/${notificationId}/read`);
}
